var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspendTweetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16913_286208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6892 18.0338C18.7616 18.6997 17.3292 20.4397 17.1246 22.5449L11.8692 15.413L0.938477 0.537109H7.83078L15.8539 11.439L20.6892 18.0338Z",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7847 26.3145H26.7632C26.7632 26.3145 26.7847 26.3145 26.774 26.3037H26.7847V26.3145Z",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.938477 26.3149L11.8692 15.413M15.8431 11.4497L26.7846 0.537109",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8614 23.0923C27.8614 24.2952 27.463 25.4123 26.7738 26.3037C26.7738 26.3145 26.763 26.3145 26.763 26.3145C25.7938 27.6249 24.2322 28.4626 22.4768 28.4626C20.9907 28.4626 19.6445 27.8612 18.6753 26.8837L19.623 25.9386L23.5968 21.9752L26.2784 19.3008C27.2584 20.2674 27.8614 21.61 27.8614 23.0923Z",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2784 19.3015L23.5969 21.976L19.6231 25.9393L18.6754 26.8845C17.6954 25.9178 17.0923 24.5752 17.0923 23.093C17.0923 22.9104 17.1031 22.7278 17.1246 22.556C17.3292 20.4401 18.7615 18.7001 20.6892 18.0341C21.2492 17.8301 21.8523 17.7227 22.4769 17.7227C23.9631 17.7227 25.3092 18.3241 26.2784 19.3015Z",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6752 26.8838L18.5029 27.0556",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4506 19.1289L26.2783 19.3008",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16913_286208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 29,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendTweetIcon);
export default __webpack_public_path__ + "static/media/suspendTweetIcon.b5fe8c0fea713370419ca1553b290b12.svg";
export { ForwardRef as ReactComponent };